import React from 'react'

import data from '../../../../data/wells'
import { WellsIcon } from '../../../../icons'

import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const Wells = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="wells"
            icon={() => <WellsIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as WellDescription }

export default Wells
